import React, { useState } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, Grid, Typography,
} from "@material-ui/core";
import { LocationOn as LocationOnIcon } from "@material-ui/icons";
import toastError from "../../errors/toastError";
import api from "../../services/api";
import { toast } from "react-toastify";

const LocationSendModal = ({ open, onClose, ticketId }) => {
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [name, setName] = useState("");
  const [address, setAddress] = useState("");
  const [loading, setLoading] = useState(false);

  const handleGetCurrentLocation = () => {
    if (!navigator.geolocation) {
      toast.error("Geolocalização não suportada pelo navegador");
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        setLatitude(String(pos.coords.latitude));
        setLongitude(String(pos.coords.longitude));
      },
      () => toast.error("Não foi possível obter sua localização")
    );
  };

  const handleSend = async () => {
    if (!latitude || !longitude) {
      toast.error("Informe latitude e longitude");
      return;
    }
    setLoading(true);
    try {
      await api.post(`/messages/${ticketId}`, {
        body: `\u{1F4CD} ${name || "Localização"}\n${address || ""}\nhttps://maps.google.com/?q=${latitude},${longitude}`,
      });
      toast.success("Localização enviada");
      handleClose();
    } catch (err) {
      toastError(err);
    }
    setLoading(false);
  };

  const handleClose = () => {
    setLatitude("");
    setLongitude("");
    setName("");
    setAddress("");
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Enviar Localização</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Button variant="outlined" color="primary" fullWidth
              onClick={handleGetCurrentLocation} startIcon={<LocationOnIcon />}>
              Usar minha localização atual
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="caption" color="textSecondary">
              Ou informe manualmente:
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <TextField label="Latitude" value={latitude}
              onChange={(e) => setLatitude(e.target.value)}
              variant="outlined" size="small" fullWidth placeholder="-23.5505" />
          </Grid>
          <Grid item xs={6}>
            <TextField label="Longitude" value={longitude}
              onChange={(e) => setLongitude(e.target.value)}
              variant="outlined" size="small" fullWidth placeholder="-46.6333" />
          </Grid>
          <Grid item xs={12}>
            <TextField label="Nome do local" value={name}
              onChange={(e) => setName(e.target.value)}
              variant="outlined" size="small" fullWidth placeholder="Ex: Escritório" />
          </Grid>
          <Grid item xs={12}>
            <TextField label="Endereço" value={address}
              onChange={(e) => setAddress(e.target.value)}
              variant="outlined" size="small" fullWidth placeholder="Ex: Rua X, 123" />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancelar</Button>
        <Button onClick={handleSend} color="primary" variant="contained"
          disabled={loading || !latitude || !longitude}>
          {loading ? "Enviando..." : "Enviar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LocationSendModal;
